import React from 'react'
import { View, Text, KeyboardAvoidingView, Platform, Keyboard } from 'react-native'
import CS from '../../../constants/Styles';
import { TextInputContainer, Button } from '../../../components';
import UserAvatar from '../../../components/Users/UserAvatar';
import styles from './styles';

export const DescriptionChange = ({ item, acceptChange, rejectChange, makeChange, scrollRef }) => {
  const [newValue, setNewValue] = React.useState(item.new_value);
  const [editable, setEditable] = React.useState(false);
  let textInput = React.useRef(null);

  // React.useEffect(() => {
  //   Keyboard.addListener('keyboardDidShow', _keyboardDidShow);
  //   Keyboard.addListener('keyboardDidHide', _keyboardDidHide);

  //   // cleanup function
  //   return () => {
  //     Keyboard.removeListener('keyboardDidShow', _keyboardDidShow);
  //     Keyboard.removeListener('keyboardDidHide', _keyboardDidHide);
  //   };
  // }, []);

  // const _keyboardDidShow = () => {
  //   console.log('Keyboard Shown');
  //   scrollRef.current.scrollToEnd({ animated: true });
  // };

  // const _keyboardDidHide = () => {
  //   console.log('Keyboard Hidden');
  // };

  const onChangeNewValue = (val) => {
    setNewValue(val);
  }

  const accept = () => {
    console.log('accept()');
    acceptChange(item);
  }
  const reject = () => {
    console.log('reject()');
    rejectChange(item);
  }
  const makeAChange = () => {
    console.log('makeAChange');
    setEditable(true);
    setTimeout(() => {
      textInput.current.focus();
    }, 100);
  }
  const saveChange = () => {
    if(item.new_value !== newValue){
      makeChange(item, newValue);
    }
    console.log('saveChange')
    setEditable(false);
  }
  const cancelChange = () => {
    setNewValue(item.new_value);
    setEditable(false);
  }

  return (
    <View>
      {/* <Text style={[CS.smallTitle, CS.lightText]}>Description</Text> */}
      <View style={[CS.rowContainer, { marginBottom: 20 }]}>
        <UserAvatar userId={item.avatar.id} avatar={item.avatar.version} size='medium' />
        <Text style={[CS.smallText, CS.lightBlueText, { marginLeft: 10 }, CS.flex]}>{item.memo}</Text>
      </View>
      <Text style={[CS.smallText, CS.lightBlueText, CS.boldText, { marginBottom: 10 }]}>From</Text>
      <View style={[styles.description, styles.oldDescription]}>
        <Text style={[CS.smallText, CS.lightBlueText]}>{item.old_value}</Text>
      </View>
      <Text style={[CS.smallText, CS.lightBlueText, CS.boldText, { marginBottom: 10 }]}>To</Text>
      {!editable && 
        <View style={[styles.description, styles.newDescription]}>
          <Text style={[CS.smallText, CS.blueText]}>{item.new_value}</Text>
        </View>
      }
      {editable &&
        <TextInputContainer
          placeholder='Provide a summary of what your project includes.'
          onChangeText={(t) => onChangeNewValue(t)}
          inputRef={textInput}
          // isInvalid={isInvalid.projectDescription}
          // returnKeyType='done'
          value={newValue}
          inputStyle={[styles.descriptionInput, (!editable && styles.disabled)]}
          multiline={true}
          numberOfLines={6}
          autoCorrect={false}
          spellCheck={true}
          editable={editable}
        />
      }
      {!editable && 
        <View style={CS.rowContainer}>
          <View style={styles.buttonLeft}>
            <Button text='Accept' onPress={() => accept} />
          </View>
          <View style={styles.buttonMiddle}>
            <Button text='Reject' onPress={() => reject} color='red' />
          </View>
          <View style={styles.buttonRight}>
            <Button text='Change' onPress={() => makeAChange} color='blue' />
          </View>
        </View>
      }
      {editable &&
        <View style={[CS.rowContainer, { marginTop: 10, marginBottom: 10 }]}>
          <View style={CS.buttonLeft}>
            <Button text='Save' onPress={() => saveChange} color='blue' />
          </View>
          <View style={CS.buttonRight}>
            <Button text='Cancel' onPress={() => cancelChange} color='red' />
          </View>
        </View>
      }
    </View>
  );
}

export default DescriptionChange;